import { useState, useEffect, useCallback } from 'react';
import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import {
  useNotificationsAuthorizationsList,
  useBulkSelectedAuthorizations,
  useOnMassiveAuthorizationSelection,
  useNotificationsLoadingState,
} from '../contexts';

const useBulkCheckboxLogicHandler = () => {
  const [isChecked, setIsChecked] = useState(false);
  const { isExtraSmallScreen: isMobile } = useScreenDetector();
  const mandatesListData = useNotificationsAuthorizationsList();
  const onMassiveAuthorizationSelection = useOnMassiveAuthorizationSelection();
  const bulkSelectedAuthorizations = useBulkSelectedAuthorizations();
  const isLoadingAuthorizationList = useNotificationsLoadingState('isLoadingPendingAuthorizations');

  const isIntermediate = Boolean(
    !isEmpty(bulkSelectedAuthorizations) &&
      mandatesListData &&
      mandatesListData?.length > bulkSelectedAuthorizations.length,
  );

  const onChange = useCallback(
    (e: any) => {
      setIsChecked(e.target.checked);
      onMassiveAuthorizationSelection(e.target.checked);
    },
    [onMassiveAuthorizationSelection],
  );

  const haveSameLength = mandatesListData?.length === bulkSelectedAuthorizations.length;

  useEffect(() => {
    if (haveSameLength) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [haveSameLength]);

  return {
    isChecked,
    isLoadingAuthorizationList,
    onChange,
    isIntermediate,
    isMobile,
  };
};

export { useBulkCheckboxLogicHandler };
